<template>
  <div class="phone-assist">
    <div class="phone-assist__trigger">
      <div class="phone-assist__search">
        <AutoBusca
          id="consulta_fone"
          item_id="id"
          item_text="nome"
          item_campos="cli.id as id, substr(cli.id::text,4) ||' ('|| UPPER(TRIM(cli.ori)) ||') '|| TRIM(UPPER(cli.nome)) || ' - '  || TRIM(cli.fone) || ' ('||TRIM(cli.cidade)||')' as nome"
          item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))"
          item_left=""
          tabela="consulta_fones cli"
          :value="codigo"
          @getID="getID"
          :label="'Buscar telefone, cliente ou cadastro'"
        />
      </div>

      <v-btn
        color="primary"
        class="phone-assist__new"
        @click="novoFone"
      >
        <v-icon left>mdi-plus</v-icon>
        Novo fone
      </v-btn>
    </div>

    <v-dialog
      v-model="modal_detalhes"
      max-width="1120"
      scrollable
      transition="dialog-top-transition"
      content-class="phone-dialog"
    >
      <v-card class="phone-dialog__card">
        <div class="phone-dialog__hero">
          <div class="phone-dialog__hero-copy">
            <span class="phone-dialog__eyebrow">{{ modalEyebrow }}</span>
            <h2>{{ modalTitulo }}</h2>
            <p>
              Preencha os dados principais de contato e endereco. Os campos
              mais importantes ficam agrupados para facilitar o cadastro.
            </p>

            <div class="phone-dialog__meta">
              <v-chip small label class="phone-dialog__chip">
                {{ tipoRegistro }}
              </v-chip>
              <v-chip v-if="fones.id" small label class="phone-dialog__chip">
                ID {{ fones.id }}
              </v-chip>
            </div>
          </div>

          <div class="phone-dialog__hero-icon">
            <v-icon size="72">mdi-card-account-phone-outline</v-icon>
          </div>

          <v-btn
            icon
            class="phone-dialog__close"
            @click="fecharModal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="phone-dialog__content">
          <div class="phone-form">
            <section class="phone-form__section">
              <div class="phone-form__section-head">
                <strong>Identificacao</strong>
                <span>Dados basicos para localizar o cadastro.</span>
              </div>

              <b-row>
                <b-col cols="12" md="6">
                  <v-text-field
                    label="Nome"
                    placeholder="Nome do contato ou referencia"
                    outlined
                    v-model="fones.nome"
                    hide-details="auto"
                    prepend-inner-icon="mdi-account-outline"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="6">
                  <v-text-field
                    label="Razao social"
                    placeholder="Empresa ou razao social"
                    outlined
                    v-model="fones.razao"
                    hide-details="auto"
                    prepend-inner-icon="mdi-domain"
                  ></v-text-field>
                </b-col>
              </b-row>
            </section>

            <section class="phone-form__section">
              <div class="phone-form__section-head">
                <strong>Contato</strong>
                <span>Telefones e e-mail para retorno rapido.</span>
              </div>

              <b-row>
                <b-col cols="12" md="3">
                  <v-text-field
                    label="Telefone principal"
                    placeholder="Nao informado"
                    outlined
                    v-model="fones.fone"
                    hide-details="auto"
                    maxlength="15"
                    v-mask="['(##)####-####', '(##)#####-####']"
                    prepend-inner-icon="mdi-phone-outline"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="3">
                  <v-text-field
                    label="Telefone secundario"
                    placeholder="Nao informado"
                    outlined
                    v-model="fones.fone2"
                    hide-details="auto"
                    maxlength="15"
                    v-mask="['(##)####-####', '(##)#####-####']"
                    prepend-inner-icon="mdi-phone-plus-outline"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="6">
                  <v-text-field
                    label="E-mail"
                    placeholder="contato@empresa.com"
                    outlined
                    v-model="fones.email"
                    hide-details="auto"
                    prepend-inner-icon="mdi-email-outline"
                  ></v-text-field>
                </b-col>
              </b-row>
            </section>

            <section class="phone-form__section">
              <div class="phone-form__section-head">
                <strong>Endereco</strong>
                <span>Informacoes para localizacao e atendimento.</span>
              </div>

              <b-row>
                <b-col cols="12" md="3">
                  <v-text-field
                    label="CEP"
                    placeholder="00000-000"
                    outlined
                    v-model="fones.cep"
                    hide-details="auto"
                    maxlength="10"
                    v-mask="['#####-###']"
                    prepend-inner-icon="mdi-mailbox-outline"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="7">
                  <v-text-field
                    label="Rua / avenida / logradouro"
                    placeholder="Endereco principal"
                    outlined
                    v-model="fones.endereco"
                    hide-details="auto"
                    prepend-inner-icon="mdi-map-marker-outline"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="2">
                  <v-text-field
                    label="Numero"
                    placeholder="S/N"
                    outlined
                    v-model="fones.numero"
                    hide-details="auto"
                  ></v-text-field>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="3">
                  <v-text-field
                    label="Bairro"
                    placeholder="Bairro"
                    outlined
                    v-model="fones.bairro"
                    hide-details="auto"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="3">
                  <v-text-field
                    label="Complemento"
                    placeholder="Bloco, sala, referencia..."
                    outlined
                    v-model="fones.complement"
                    hide-details="auto"
                  ></v-text-field>
                </b-col>

                <b-col cols="12" md="6">
                  <AutoBusca
                    id="cidade"
                    item_id="codcid"
                    item_text="nome"
                    item_campos="cid.codcid, TRIM(cid.nome)||'-'||cid.uf as nome"
                    item_busca="cid.codcid::text|| '-' || TRIM(UPPER(cid.nome)) "
                    item_left=""
                    tabela="cidade cid"
                    :value="fones.codcid"
                    @getID="getID"
                    :label="'Cidade'"
                    :rdark="false"
                  />
                </b-col>
              </b-row>
            </section>
          </div>
        </v-card-text>

        <div class="phone-dialog__footer">
          <div class="phone-dialog__footer-copy">
            <strong>{{ footerResumo }}</strong>
            <span>Revise os dados antes de salvar.</span>
          </div>

          <div class="phone-dialog__footer-actions">
            <v-btn text @click="fecharModal">Cancelar</v-btn>
            <v-btn color="primary" large @click="salvarFone" :loading="salvando">
              <v-icon left>mdi-content-save-outline</v-icon>
              Salvar cadastro
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import AutoBusca from "../components/AutoBusca.vue";
import ExecutaSQL from "../domain/ExecutaSQL";
import Fones from "../domain/Fones";

export default {
  components: {
    AutoBusca,
  },
  data: () => ({
    codigo: "",
    modal_detalhes: false,
    oper: "",
    salvando: false,
    fones: {
      id: "",
      ori: "",
      nome: "",
      razao: "",
      fone: "",
      fone2: "",
      email: "",
      endereco: "",
      numero: "",
      bairro: "",
      cep: "",
      complement: "",
      codcid: "",
    },
    lbl_modal: "",
  }),
  computed: {
    tipoRegistro() {
      if (this.fones.ori === "cli") return "Cliente";
      if (this.fones.id) return "Cadastro existente";
      return "Novo cadastro";
    },
    modalEyebrow() {
      return this.fones.id ? "Edicao de cadastro" : "Novo cadastro";
    },
    modalTitulo() {
      if (this.lbl_modal) return this.lbl_modal;
      return "Cadastro de fones";
    },
    footerResumo() {
      if (this.fones.nome) return this.fones.nome;
      if (this.fones.razao) return this.fones.razao;
      return "Cadastro pronto para salvar";
    },
  },
  methods: {
    getID(val) {
      if (val.id == "consulta_fone" && val.value) {
        this.consultaFone(val.value);
        return;
      }

      if (val.id == "cidade") {
        this.fones.codcid = val.value || "";
      }
    },
    consultaFone(id) {
      let wsql = "";
      let ori = id.substring(0, 3);
      id = id.substring(3);

      if (ori == "cli") {
        wsql =
          "SELECT 'cli'::char(3) as ori, id, nome, cnpj as cgc, razao, fone, fone2, email, " +
          "endereco, numero, bairro, complement, codcid, cep " +
          "FROM cliente WHERE id = " +
          id;

        this.lbl_modal = "Cadastro de cliente";
      } else {
        wsql =
          "SELECT 'fon'::char(3) as ori, id, nome, ''::text as razao,cgc, " +
          "fone, fone2, email, endereco, numero, bairro, " +
          "complement, codcid, cep FROM fones WHERE id = " +
          id;

        this.lbl_modal = "Cadastro de fones";
      }

      Vue.Loading("Buscando...", "", this);
      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function (ret) {
          this.fones = Object.assign({}, this.fones, ret[0] || {});
          this.modal_detalhes = true;
          this.codigo = null;
          Vue.CloseLoading(this);
        },
        () => {
          Vue.CloseLoading(this);
        }
      );
    },
    novoFone() {
      this.limpaCampos();
      this.lbl_modal = "Novo cadastro de fones";
      this.modal_detalhes = true;
    },
    fecharModal() {
      this.lbl_modal = "";
      this.modal_detalhes = false;
      this.codigo = null;
      this.salvando = false;
    },
    salvarFone() {
      this.salvando = true;
      Vue.Loading("Salvando...", "", this);
      this.service = new Fones(this.$resource);
      this.service.save([this.fones]).then(
        function () {
          this.salvando = false;
          Vue.CloseLoading(this);
          this.modal_detalhes = false;
          this.codigo = null;
        },
        () => {
          this.salvando = false;
          Vue.CloseLoading(this);
        }
      );
    },
    limpaCampos() {
      this.fones = {
        id: "",
        ori: "",
        nome: "",
        razao: "",
        fone: "",
        fone2: "",
        email: "",
        endereco: "",
        numero: "",
        bairro: "",
        cep: "",
        complement: "",
        codcid: "",
      };
    },
  },
};
</script>

<style>
.phone-assist {
  width: 100%;
}

.phone-assist__trigger {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
}

.phone-assist__search .v-input__slot {
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.9) !important;
}

.phone-assist__new {
  min-width: 144px;
}

.phone-dialog {
  box-shadow: none !important;
}

.phone-dialog__card {
  overflow: hidden;
  border-radius: 28px !important;
}

.phone-dialog__hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px;
  gap: 18px;
  padding: 26px 28px 22px;
  color: #e2e8f0;
  background:
    radial-gradient(circle at top left, rgba(103, 183, 204, 0.2), transparent 26%),
    radial-gradient(circle at 80% 20%, rgba(45, 212, 191, 0.14), transparent 22%),
    linear-gradient(145deg, #0a3440 0%, #0f4c5c 54%, #146c7d 100%);
}

.phone-dialog__eyebrow {
  display: inline-block;
  margin-bottom: 10px;
  color: rgba(226, 232, 240, 0.82);
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.phone-dialog__hero-copy h2 {
  margin: 0;
  color: #f8fafc;
  font-size: 1.95rem;
  line-height: 1.02;
  letter-spacing: -0.04em;
}

.phone-dialog__hero-copy p {
  max-width: 62ch;
  margin: 12px 0 0;
  color: rgba(226, 232, 240, 0.78);
  line-height: 1.7;
}

.phone-dialog__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.phone-dialog__chip {
  background: rgba(255, 255, 255, 0.14) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.phone-dialog__hero-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(248, 250, 252, 0.92);
}

.phone-dialog__close {
  position: absolute !important;
  top: 16px;
  right: 16px;
  color: #f8fafc !important;
}

.phone-dialog__content {
  padding: 24px 24px 12px !important;
}

.phone-form {
  display: grid;
  gap: 18px;
}

.phone-form__section {
  padding: 18px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 22px;
  background: rgba(248, 250, 252, 0.78);
}

.phone-form__section-head {
  margin-bottom: 14px;
}

.phone-form__section-head strong {
  display: block;
  color: #0f172a;
  font-size: 1rem;
}

.phone-form__section-head span {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 0.86rem;
}

.phone-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 24px 24px;
}

.phone-dialog__footer-copy strong {
  display: block;
  color: #0f172a;
  font-size: 0.98rem;
}

.phone-dialog__footer-copy span {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 0.84rem;
}

.phone-dialog__footer-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

@media (max-width: 960px) {
  .phone-assist__trigger {
    grid-template-columns: 1fr;
  }

  .phone-assist__new {
    width: 100%;
  }

  .phone-dialog__hero {
    grid-template-columns: 1fr;
  }

  .phone-dialog__hero-icon {
    justify-content: flex-start;
  }

  .phone-dialog__footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .phone-dialog__footer-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .phone-dialog__hero {
    padding: 24px 18px 18px;
  }

  .phone-dialog__hero-copy h2 {
    font-size: 1.65rem;
  }

  .phone-dialog__content {
    padding: 18px 14px 10px !important;
  }

  .phone-form__section {
    padding: 14px;
  }

  .phone-dialog__footer {
    padding: 14px 14px 18px;
  }

  .phone-dialog__footer-actions {
    width: 100%;
    flex-direction: column-reverse;
  }

  .phone-dialog__footer-actions .v-btn {
    width: 100%;
  }
}
</style>
